const BASE_PATH = '/repairs';

export enum Route {
  AppointmentTime = `${BASE_PATH}/appointment-time`,
  BillingDetails = `${BASE_PATH}/billing-details`,
  CancelAppointment = `${BASE_PATH}/cancel-appointment`,
  ConfirmCancel = `${BASE_PATH}/confirm-cancel`,
  Confirmation = `${BASE_PATH}/confirmation`,
  CustomerDetails = `${BASE_PATH}/customer-details`,
  DamageType = `${BASE_PATH}/damage-type`,
  DeliverySelection = `${BASE_PATH}/delivery-selection`,
  DeviceDetails = `${BASE_PATH}/device-details`,
  DeviceType = `${BASE_PATH}/device-type`,
  Landing = `${BASE_PATH}`,
}
